import { APP_INSTALLER_SCOPE } from '@wix/app-installer-fed-serverless/dist/consts';
import Experiments from '@wix/wix-experiments';
export const loadExperiments = errors => {
  const installerExperiments = new Experiments();
  installerExperiments.load(APP_INSTALLER_SCOPE).catch(e => errors.push(e));
  return installerExperiments;
};
//# sourceMappingURL=experiments.js.map